import { useMemo, useState } from 'react';

export function useColumnVisibility<K extends string>(all: readonly ColumnDef<K>[]) {
  const [visibleColumns, setVisibleColumns] = useState<Set<K>>(
    () => new Set(all.filter((c) => c.visibleByDefault).map((c) => c.key)),
  );

  const toggleColumn = (key: K) => {
    setVisibleColumns((prev) => {
      const next = new Set(prev);
      if (next.has(key) && next.size === 1) return next; // Always keep 1 column visible
      if (next.has(key)) next.delete(key);
      else next.add(key);
      return next;
    });
  };

  const filteredColumns = useMemo(() => all.filter((c) => visibleColumns.has(c.key)), [all, visibleColumns]);

  return {
    filteredColumns,
    setVisibleColumns,
    toggleColumn,
    visibleColumns,
  };
}
